const messages = {
  removeStyleColorsTitle: 'Remove Style Colors with No Quantities',
  removeStyleColorsSubTitle:
    'Select the style colors without quantities you want to remove from your order(s). Then click the "Review" button.',
  returnToOrders: 'Return to Orders',
  review: 'Review',
  poNumber: 'PO#',
  countSelectedStyleColorsSelected: (countSelectedStyleColors, totalCount) =>
    countSelectedStyleColors === 0 ? (
      <span>
        <var>{totalCount}</var> total
      </span>
    ) : (
      <span>
        <var>{countSelectedStyleColors}</var> style colors selected from{' '}
        <var>{totalCount}</var> orders total
      </span>
    ),
  submit: 'Submit',
  previousPage: 'Previous Page',
  reviewPageTitle: 'Review and Submit',
  reviewPageSubTitle:
    'Confirm that these are the style colors without quantities you want to remove on your order(s) and click the ' +
    '"Submit" button.',
  successNotification: (
    countSelectedStyleColors,
    countUnselectedStyleColors,
  ) => (
    <div>
      <div>
        You removed <var>{countSelectedStyleColors}</var> style color(s).
      </div>
      <div>
        You kept <var>{countUnselectedStyleColors}</var> style color(s).
      </div>
    </div>
  ),
}

export default messages
